"use strict";

var _toConsumableArray = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lintConfig = exports.lintDocument = exports.lintFromString = exports.lint = void 0;

var resolve_1 = require("./resolve");

var visitors_1 = require("./visitors");

var oas3_1_1 = require("./types/oas3_1");

var oas3_1 = require("./types/oas3");

var oas2_1 = require("./types/oas2");

var walk_1 = require("./walk");

var config_1 = require("./config/config");

var types_1 = require("./types");

var rules_1 = require("./config/rules");

var ajv_1 = require("./rules/ajv");

var oas_types_1 = require("./oas-types");

var redocly_yaml_1 = require("./types/redocly-yaml");

var spec_1 = require("./rules/common/spec");

var builtIn_1 = require("./config/builtIn");

function lint(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ref, _opts$externalRefReso, externalRefResolver, document;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ref = opts.ref, _opts$externalRefReso = opts.externalRefResolver, externalRefResolver = _opts$externalRefReso === void 0 ? new resolve_1.BaseResolver(opts.config.resolve) : _opts$externalRefReso;
            _context.next = 3;
            return externalRefResolver.resolveDocument(null, ref, true);

          case 3:
            document = _context.sent;
            return _context.abrupt("return", lintDocument(Object.assign(Object.assign({
              document: document
            }, opts), {
              externalRefResolver: externalRefResolver,
              config: opts.config.lint
            })));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.lint = lint;

function lintFromString(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var source, absoluteRef, _opts$externalRefReso2, externalRefResolver, document;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            source = opts.source, absoluteRef = opts.absoluteRef, _opts$externalRefReso2 = opts.externalRefResolver, externalRefResolver = _opts$externalRefReso2 === void 0 ? new resolve_1.BaseResolver(opts.config.resolve) : _opts$externalRefReso2;
            document = resolve_1.makeDocumentFromString(source, absoluteRef || '/');
            return _context2.abrupt("return", lintDocument(Object.assign(Object.assign({
              document: document
            }, opts), {
              externalRefResolver: externalRefResolver,
              config: opts.config.lint
            })));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.lintFromString = lintFromString;

function lintDocument(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var document, customTypes, externalRefResolver, config, oasVersion, oasMajorVersion, rules, types, ctx, preprocessors, regularRules, normalizedVisitors, resolvedRefMap;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ajv_1.releaseAjvInstance(); // FIXME: preprocessors can modify nodes which are then cached to ajv-instance by absolute path

            document = opts.document, customTypes = opts.customTypes, externalRefResolver = opts.externalRefResolver, config = opts.config;
            oasVersion = oas_types_1.detectOpenAPI(document.parsed);
            oasMajorVersion = oas_types_1.openAPIMajor(oasVersion);
            rules = config.getRulesForOasVersion(oasMajorVersion);
            types = types_1.normalizeTypes(config.extendTypes((customTypes !== null && customTypes !== void 0 ? customTypes : oasMajorVersion === oas_types_1.OasMajorVersion.Version3) ? oasVersion === oas_types_1.OasVersion.Version3_1 ? oas3_1_1.Oas3_1Types : oas3_1.Oas3Types : oas2_1.Oas2Types, oasVersion), config);
            ctx = {
              problems: [],
              oasVersion: oasVersion,
              visitorsData: {}
            };
            preprocessors = rules_1.initRules(rules, config, 'preprocessors', oasVersion);
            regularRules = rules_1.initRules(rules, config, 'rules', oasVersion);
            normalizedVisitors = visitors_1.normalizeVisitors([].concat(_toConsumableArray(preprocessors), _toConsumableArray(regularRules)), types);
            _context3.next = 12;
            return resolve_1.resolveDocument({
              rootDocument: document,
              rootType: types.DefinitionRoot,
              externalRefResolver: externalRefResolver
            });

          case 12:
            resolvedRefMap = _context3.sent;
            walk_1.walkDocument({
              document: document,
              rootType: types.DefinitionRoot,
              normalizedVisitors: normalizedVisitors,
              resolvedRefMap: resolvedRefMap,
              ctx: ctx
            });
            return _context3.abrupt("return", ctx.problems.map(function (problem) {
              return config.addProblemToIgnore(problem);
            }));

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.lintDocument = lintDocument;

function lintConfig(opts) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var document, ctx, config, types, rules, normalizedVisitors;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            document = opts.document;
            ctx = {
              problems: [],
              oasVersion: oas_types_1.OasVersion.Version3_0,
              visitorsData: {}
            };
            config = new config_1.LintConfig({
              plugins: [builtIn_1.defaultPlugin],
              extends: [],
              rules: {
                spec: 'error'
              }
            });
            types = types_1.normalizeTypes(redocly_yaml_1.ConfigTypes, config);
            rules = [{
              severity: 'error',
              ruleId: 'spec',
              visitor: spec_1.OasSpec({
                severity: 'error'
              })
            }];
            normalizedVisitors = visitors_1.normalizeVisitors(rules, types);
            walk_1.walkDocument({
              document: document,
              rootType: types.ConfigRoot,
              normalizedVisitors: normalizedVisitors,
              resolvedRefMap: new Map(),
              ctx: ctx
            });
            return _context4.abrupt("return", ctx.problems);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.lintConfig = lintConfig;